import React, { useState } from 'react';
import { Typography, Button, TextField, Container } from '@mui/material';
import './register.css';
import DisabilityDialog from './DisabilityDialog';
import SuccessDialog from './SuccessDialog';
import dniImage from './dni.png';
import logo from './logo.png';
import iconAdmision from './iconAdmision.json';
import Lottie from 'lottie-react';
import CreateDialog from './CreateDialog';

function Register(props) {
  const [dni, setDNI] = useState('');
  const [data, setData] = useState(null);
  const [message, setMessage] = useState('');
  const [showLayoutHome, setShowLayoutHome] = useState(false);
  const [showMessage, setShowMessage] = useState(false);
  const [openDisabilityDialog, setOpenDisabilityDialog] = useState(false);
  const [openSuccessDialog, setOpenSuccessDialog] = useState(false);
  const [hasDisability, setHasDisability] = useState(false);
  const [showCreateDialog, setShowCreateDialog] = useState(false);
  const [messageSuccess, setMessageSuccess] = useState("");

  // Si el dominio es cola-farm-casa.chatup.pe, NO mostrar el diálogo y marcar NO preferencial.
  const IS_FORCE_NO_PREFERRED =
    typeof window !== 'undefined' &&
    window.location.hostname === 'cola-farm-casa.chatup.pe';

  const handleSACARCITA = () => {
    setShowLayoutHome(true);
    setDNI('');
  };

  const handleRegister = () => {
    if (dni.length > 7) {
      if (IS_FORCE_NO_PREFERRED) {
        // Forzar "no preferencial" y registrar directo sin diálogo
        setHasDisability(false);
        fetchRegister(false);
      } else {
        setOpenDisabilityDialog(true);
      }
    }
  };

  const postDataToServer = (name, isPreferredFlag) => {
    const currentDate = new Date().toISOString();

    const postData = {
      name: name,
      isPreferred: Boolean(isPreferredFlag), // usar flag explícito
      registrationDate: currentDate,
      status: 'pending',
    };

    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(postData),
    };

    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/colas`, requestOptions)
      .then((response) => {
        if (!response.ok) throw new Error('Network response was not ok');
        return response.json();
      })
      .then(() => {
        setShowLayoutHome(false);
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  };

  // Acepta el flag preferencial para evitar leer un state desactualizado
  const fetchRegister = (isPreferredFlag = false) => {
    setData(null);
    props.handleLoading(true);

    if (dni.length > 7) {
      fetch(`${process.env.REACT_APP_BACKEND_URL}/api/reniec?dni=${dni}`)
        .then((response) => response.json())
        .then((data) => {
          if (data) {
            setMessageSuccess(`¡Hola, ${data?.nombreFormateado}! Continúe en módulo.`);
            postDataToServer(`${data?.nombreFormateado}`, isPreferredFlag);
            setData(data);
            setShowMessage(true);
            setOpenSuccessDialog(true);
            setDNI('');
            setTimeout(() => setOpenSuccessDialog(false), 5000);
          } else {
            setMessageSuccess(`Listo, lo llamaremos en módulo como: VISITANTE ${dni}`);
            postDataToServer(`VISITANTE ${dni}`, isPreferredFlag);
            setData({ nombre: `VISITANTE ${dni}` });
            setOpenSuccessDialog(true);
          }
          props.handleLoading(false);
        })
        .catch(() => {
          setMessageSuccess(`Listo, lo llamaremos en módulo como: VISITANTE ${dni}`);
          postDataToServer(`VISITANTE ${dni}`, isPreferredFlag);
          setOpenSuccessDialog(true);
          setData({ nombre: `VISITANTE ${dni}` });
          props.handleLoading(false);
        });
    }
  };

  const handleYesDisability = () => {
    setHasDisability(true);
    setOpenDisabilityDialog(false);
    fetchRegister(true); // preferencial
    setOpenSuccessDialog(true);
  };

  const handleNoDisability = () => {
    setHasDisability(false);
    setOpenDisabilityDialog(false);
    fetchRegister(false); // NO preferencial
    setOpenSuccessDialog(true);
  };

  const handleSuccessDialogClose = () => {
    setData(null);
    setOpenSuccessDialog(false);
    setShowMessage(false);
    setDNI('');
    props.handleLoading(false);
  };

  const handleDataUpdate = (name) => {
    props.handleLoading(false);
    setMessage(`Pase a plataforma, ${name}`);
    setShowMessage(true);
    setOpenSuccessDialog(true);
    setTimeout(() => {
      setShowMessage(false);
      setOpenSuccessDialog(false);
      setDNI('');
    }, 7000);
  };

  return (
    <div className="root">
      <Container maxWidth="xxl" className="formContainer">
        <img src={logo} alt="DNI" style={{ width: '200px' }} />
        <div className="lineBanner" />
        <div className="titleContainer">
          <Typography variant="h4" gutterBottom className="titleBanner2">
            Bienvenido a
          </Typography>
          <Typography variant="h4" gutterBottom className="titleBanner">
            Clínica Arequipa
          </Typography>
        </div>

        <div className="containerData">
          {showLayoutHome ? (
            <>
              <div style={{ display: 'flex', paddingBottom: '20px' }}>
                <TextField
                  keyboardType="numeric"
                  inputProps={{ inputMode: 'numeric' }}
                  className="formField"
                  variant="outlined"
                  value={dni}
                  autoFocus={true}
                  onChange={(e) => setDNI(e.target.value)}
                  sx={{ '.MuiInputBase-input': { fontSize: '2.55rem' } }}
                />
                <Button className="submitButton" variant="contained" color="primary" onClick={handleRegister}>
                  Registrar
                </Button>
              </div>
              <Typography gutterBottom className="titleBanner3">
                Ingrese su DNI o Pasaporte
              </Typography>
              <img src={dniImage} alt="DNI" style={{ width: '400px' }} />

              <Button variant="outlined" color="primary" onClick={() => setShowLayoutHome(false)}>
                Regresar
              </Button>
            </>
          ) : (
            <Button variant="contained" color="primary" onClick={handleSACARCITA} className="button-register">
              <div style={{ marginTop: '-40px' }}>
                <Lottie animationData={iconAdmision} style={{ height: '200px' }} />
                <div className="labelButton" style={{ marginTop: '-20px' }}>
                  Sacar Cita
                </div>
              </div>
            </Button>
          )}

          <CreateDialog
            open={showCreateDialog}
            onClose={() => setShowCreateDialog(false)}
            fullWidth
            onRegister={handleDataUpdate}
          />

          {/* Render del diálogo. No se abrirá si IS_FORCE_NO_PREFERRED es true */}
          <DisabilityDialog
            open={openDisabilityDialog}
            onClose={() => setOpenDisabilityDialog(false)}
            onYes={handleYesDisability}
            onNo={handleNoDisability}
          />

          {data && (
            <SuccessDialog open={openSuccessDialog} onClose={handleSuccessDialogClose} message={messageSuccess} />
          )}
        </div>
      </Container>
    </div>
  );
}

export default Register;
